import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.jpg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiFillFacebook,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";

function Home2() {
  const { t } = useLanguage();
  const h = t.home;

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              {h.introduceTitle}
              <span className="purple">{h.introduceHighlight}</span>
              {h.introduceSuffix}
            </h1>
            <p className="home-about-body">
              {h.body1
                .split(/(\{[^}]+\})/)
                .map((part, i) => {
                  const map = {
                    "{backend}": "Backend Developer",
                    "{exp}": "3 years of experience",
                    "{enterprise}": "enterprise systems",
                    "{java}": "Java",
                    "{springboot}": "Spring Boot",
                    "{kafka}": "Kafka",
                    "{postgres}": "PostgreSQL",
                    "{oracle}": "Oracle",
                  };
                  if (map[part]) return <b className="purple" key={i}>{map[part]}</b>;
                  return part;
                })}
              <br /><br />
              {h.body2
                .split(/(\{[^}]+\})/)
                .map((part, i) => {
                  const map = {
                    "{microservices}": "microservices",
                    "{dbperf}": "database performance",
                    "{distributed}": "distributed systems",
                  };
                  if (map[part]) return <b className="purple" key={i}>{map[part]}</b>;
                  return part;
                })}
              <br /><br />
              {h.body3
                .split(/(\{[^}]+\})/)
                .map((part, i) => {
                  const map = {
                    "{traffic}": "traffic management",
                    "{gov}": "government-scale applications",
                  };
                  if (map[part]) return <b className="purple" key={i}>{map[part]}</b>;
                  return part;
                })}
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img
                src={myImg}
                className="img-fluid"
                alt="avatar"
                style={{
                  borderRadius: "50%",
                  width: "250px",
                  height: "250px",
                  objectFit: "cover",
                  border: "4px solid #a04cd0",
                  boxShadow: "0 4px 15px rgba(160, 76, 208, 0.4)",
                }}
              />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>{h.findMeOn}</h1>
            <p>
              {h.connectText}{" "}
              <span className="purple">{h.connectHighlight}</span>
              {h.connectSuffix}
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://web.facebook.com/dn.tienes"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillFacebook />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/ngoc.tien10/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://github.com/NgocTien0110"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ngoctien0110/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
